export default __webpack_public_path__ + "static/media/coverpic1.0013cf54.png";